/**
 * Позволяет манипулировать историей браузера
 *
 * @class BrowserHistory
 */
class BrowserHistory {
	/**
	 * Устанавливает поведение восстановления прокрутки по умолчанию при навигации по истории.
	 * @param {string} [scrollRestoration='auto'] Параметр, устанавливающий поведение восстановления прокрутки.
	 * @memberof BrowserHistory
	 */
	static setScrollRestoration(settings = { scrollRestoration: 'auto' }) {
		if (history.scrollRestoration) {
			history.scrollRestoration = settings.scrollRestoration;
		}
	}

	/**
	 * Добавляет запись в стек истории сеансов браузера
	 *
	 * @param {*} [state={}] состояние или сериализуемый объект
	 * @param {string} [title='Заголовок'] заголовок (поддержка минимальная)
	 * @param {*} url адрес замены
	 * @memberof BrowserHistory
	 */
	static pushHistoryState(state = {}, title = 'Заголовок', url) {
		try {
			history.pushState(state, title, url);
		} catch (error) {
			console.error(`[js] ${error}`);
		}
	}

	/**
	 * Изменяет текущую запись истории, заменяя ее объектом состояния и URL-адресом, переданными в параметрах метода.
	 * Этот метод особенно полезен, когда вы хотите обновить объект состояния или URL-адрес текущей записи истории в ответ на какое-либо действие пользователя.
	 *
	 * @param {*} [state={}] состояние или сериализуемый объект
	 * @param {*} url заголовок (поддержка минимальная)
	 * @memberof BrowserHistory
	 */
	static replaceHistoryState(state = {}, url) {
		try {
			history.pushState(state, '', url);
		} catch (error) {
			console.error(`[js] ${error}`);
		}
	}

	/**
	 * Возвращает целое число, представляющее количество элементов в истории сеанса, включая загруженную в данный момент страницу.
	 *
	 * @return {*} length - для страницы, загруженной в новую вкладку, возвращает 1.
	 * @memberof BrowserHistory
	 */
	static getHistoryLength() {
		return history.length;
	}

	/**
	 * Возвращает значение, представляющее состояние в верхней части стека истории.
	 *
	 * @return {*} state - Это способ взглянуть на состояние, не дожидаясь события popstate.
	 * @memberof BrowserHistory
	 */
	static getHistoryState() {
		return history.state;
	}

	/**
	 * Событие popstate отправляется в окно каждый раз, когда активная запись истории меняется между двумя записями истории для одного и того же документа.
	 *
	 * @param {*} func - функция callback, которая выполняется в момент изменения состояния URL адреса страницы.
	 * @memberof BrowserHistory
	 */
	static createEventListener(func) {
		if (func) {
			addEventListener('popstate', func);
		}
	}
}

export default BrowserHistory;
